import { ScrollBox, Select } from '@pixi/ui';

export default class ClampedScrollBox extends ScrollBox {
    makeScrollable() {
        const alreadyScrolling = Boolean(this._trackpad);
        super.makeScrollable();
        if (alreadyScrolling) return;
        this.clampAxis(this._trackpad?.xAxis);
        this.clampAxis(this._trackpad?.yAxis);
    }

    clampAxis(axis) {
        if (!axis) return;
        axis.constrain = false;
        const hold = axis.hold.bind(axis);
        const slide = axis.slide.bind(axis);
        axis.hold = (position) => {
            hold(position);
            this.pinAxis(axis);
        };
        axis.slide = (instant) => {
            slide(instant);
            this.pinAxis(axis);
        };
    }

    pinAxis(axis) {
        if (axis.position > axis.min) axis.position = axis.min;
        else if (axis.position < axis.max) axis.position = axis.max;
        else return;
        axis._speed = 0;
        axis._targetSpeed = 0;
        axis._prev = axis.position;
        axis._activeEase = undefined;
    }
}

export class ClampedSelect extends Select {
    init(options) {
        if (!this.scrollBox) {
            this.scrollBox = new ClampedScrollBox();
            this.view.addChild(this.scrollBox);
        }
        super.init(options);
    }
}
